
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postBlockUser = (params) => {
    return axios.post(`${backendHost}/api/admin/block_user`, params);
};

export {
    postBlockUser
}